module.exports = "<div *ngIf=\"message\"><span  [innerHTML] = \"message.text\"></span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./resources/assets/typescript/_copywrite/copywrite.component.html
// module id = 131
// module chunks = 0